import { GridItem, Stack } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { FC } from 'react';
import { ReleaseEnvironment } from 'types/releaseEnvironment';

type Props = {
  /** リリース環境一覧 */
  item: ReleaseEnvironment;
  /** 行クリックイベントのハンドラ */
  handleClickRow: () => void;
  componentList: { id: number | undefined; componentName: string }[];
};

export const EnvironmentListItem: FC<Props> = ({
  item,
  handleClickRow,
  componentList,
}) => (
  <ListRow onClick={handleClickRow} templateColumns="2fr 10fr">
    <GridItem>
      <TextWithTooltip
        text={item.name}
        textMaxWidth="200px"
        visibleTooltip
        tooltipMaxWidth="200px"
      />
    </GridItem>
    <GridItem>
      {item.components?.map((component, index) => (
        <Stack key={index.toString()}>
          {componentList.map(
            (list) =>
              component.id === list.id && (
                <Stack key={list.id}>
                  <TextWithTooltip
                    text={`${list.componentName} (${component.version})`}
                    textMaxWidth="600px"
                    visibleTooltip
                    tooltipMaxWidth="600px"
                  />
                </Stack>
              ),
          )}
        </Stack>
      ))}
    </GridItem>
  </ListRow>
);
